import { Navigate, Route, Routes } from "react-router-dom";
import Constants from "../constants/Index";
import { FilterContextProvider } from "../contexts/FilterContext";
import { OnboardingProvider } from "../contexts/OnboardingContext";
import { Onboarding } from "../pages/Onboarding/Template/Index";
import { PastureViewComponent } from "../pages/PaddocksMap/Maps/PastureView/Index";
import { PaddocksMapIndex } from "../pages/PaddocksMap/Template";
import { isAuthenticated } from "../services/auth";
import { TaskCreationProvider } from "../contexts/TaskCreationContext";
import { PdfPage } from "../pages/Pdf";
import DashboardCattleMapGeneral from "../pages/Dashboard/CattleMap/General";
import DashboardSupplementationInventoryControl from "../pages/Dashboard/Supplementation/InventoryControl";
import DashboardSupplementationProductReport from "../pages/Dashboard/Supplementation/ProductReport";
import DashboardSupplementationProductConsumption from "../pages/Dashboard/Supplementation/ProductConsumption";
import DashboardManagementGeneral from "../pages/Dashboard/PastureManagement/General";
import DashboardManagementMicroArea from "../pages/Dashboard/PastureManagement/MicroArea";
import DashboardCattleMapBatches from "../pages/Dashboard/CattleMap/ViewBatches";
import ExportDashboard from "../pages/Dashboard/Export";

interface PrivateRouteProps {
  component: React.ComponentType;
}

const PrivateRoute = ({ component: Component }: PrivateRouteProps) => {
  if (isAuthenticated()) return <Component />;
  return <Navigate to="/entrar" />;
};

export function AuthRoutes() {
  return (
    <OnboardingProvider>
      <FilterContextProvider>
        <TaskCreationProvider>
          <Routes>
            {/* Onboarding Route */}
            <Route
              path={Constants.ONBOARDING}
              element={<PrivateRoute component={Onboarding} />}
            />

            {/* PDF Report Route */}
            <Route 
              path={Constants.EVALUATION_REPORT} 
              element={<PrivateRoute component={PdfPage} />} 
            />

            {/* Paddocks Map Routes */}
            <Route path={Constants.PADDOCKS_MAP} element={<PrivateRoute component={PaddocksMapIndex} />}>
                <Route path="" element={<PastureViewComponent view="default-map" />} />

                <Route path={Constants.PADDOCKS_MAP_PADDOCK_TIME} element={<PastureViewComponent view="paddock-time" />} />

                <Route path={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT_TYPE} element={<PastureViewComponent view="management-type" />} />
                <Route path={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT_HEIGHT} element={<PastureViewComponent view="management-height" />} />
                <Route path={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT_RATE} element={<PastureViewComponent view="management-rate" />} />
                <Route path={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT_DAY} element={<PastureViewComponent view="management-day" />} />

                <Route path={Constants.PADDOCKS_MAP_CAPACITY} element={<PastureViewComponent view="capacity-immediate" />} />
                <Route path={Constants.PADDOCKS_MAP_CAPACITY_IMMEDIATE} element={<PastureViewComponent view="capacity-immediate" />} />
                <Route path={Constants.PADDOCKS_MAP_CAPACITY_AVAREGE} element={<PastureViewComponent view="capacity-average" />} />

                <Route path={Constants.PADDOCKS_MAP_DASHBOARD_EXPORT} element={<ExportDashboard />} />
                <Route path={Constants.PADDOCKS_MAP_DASHBOARD_CATTLE_MAP} element={<DashboardCattleMapGeneral />} />
                <Route path={Constants.PADDOCKS_MAP_DASHBOARD_CATTLE_MAP_GENERAL} element={<DashboardCattleMapGeneral />} />
                <Route path={Constants.PADDOCKS_MAP_DASHBOARD_CATTLE_MAP_BATCHES} element={<DashboardCattleMapBatches />} />
                <Route path={Constants.PADDOCKS_MAP_DASHBOARD_SUPPLEMENTATION} element={<DashboardSupplementationInventoryControl />} />
                <Route path={Constants.PADDOCKS_MAP_DASHBOARD_SUPPLEMENTATION_CONTROL} element={<DashboardSupplementationInventoryControl />} />
                <Route path={Constants.PADDOCKS_MAP_DASHBOARD_SUPPLEMENTATION_REPORT} element={<DashboardSupplementationProductReport />} />
                <Route path={Constants.PADDOCKS_MAP_DASHBOARD_SUPPLEMENTATION_CONSUMPTION} element={<DashboardSupplementationProductConsumption />} />
                <Route path={Constants.PADDOCKS_MAP_DASHBOARD_MANAGEMENT} element={<DashboardManagementGeneral />} />
                <Route path={Constants.PADDOCKS_MAP_DASHBOARD_MANAGEMENT_GENERAL} element={<DashboardManagementGeneral />} />
                <Route path={Constants.PADDOCKS_MAP_DASHBOARD_MANAGEMENT_MICROAREA} element={<DashboardManagementMicroArea />} />

            </Route>
          </Routes>
        </TaskCreationProvider>
      </FilterContextProvider>
    </OnboardingProvider>
  );
}
